import { render, staticRenderFns } from "./LearningAddPage.vue?vue&type=template&id=399ef460&scoped=true&"
import script from "./LearningAddPage.vue?vue&type=script&lang=js&"
export * from "./LearningAddPage.vue?vue&type=script&lang=js&"
import style0 from "./LearningAddPage.vue?vue&type=style&index=0&id=399ef460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ef460",
  null
  
)

export default component.exports